
import { Tooltip } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppEditIcon } from "../../Icon/AppEditIcon";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

interface IEditToggleButtonHeaderProps extends IAppButtonProps {
    selected?: boolean;
}

export const EditToggleButtonHeader = (props: IEditToggleButtonHeaderProps) => (
    <Tooltip title={props.selected ? Translations.ChangeToReadMode : Translations.ChangeToEditMode}>
        <span>
            <AppButton variant={props.selected ? "outlined" : "contained"} startIcon={<AppEditIcon />} {...props}>
                {props.selected ? Translations.EditMode : Translations.ReadMode}
            </AppButton>
        </span>
    </Tooltip>
);
